export class UnexpectedError extends Error {
  constructor() {
    super('Error inesperado');
  }
}
